const translations = {
    leave_review: {
        en: "Leave a review",
        es: "Deja un comentario",
        it: "Lascia un commento",
        pt: "Deixar um comentário",
        de: "Eine Meinung hinterlassen",
        nl: "Laat een reactie achter",
        zh: "发表评论",
        ar: "اترك تعليقاً",
        df: "Laisser un avis"
    },

    experience: {
        en: "tell us about your experience",
        es: "cuéntenos su experiencia",
        it: "raccontateci la vostra esperienza",
        pt: "fale-nos da sua experiência",
        de: "berichten Sie uns von Ihren Erfahrungen",
        nl: "vertel ons over je ervaring",
        zh: "告诉我们您的经历",
        ar: "أخبرنا عن تجربتك",
        df: "faites nous part de votre expérience"
    },

    allergens: {
        en: "Allergens",
        es: "Alérgenos",
        it: "Allergeni",
        pt: "Alergénios",
        de: "Allergene",
        nl: "Allergenen",
        zh: "过敏原",
        ar: "مسببات الحساسية",
        df: "Allergènes"
    },
    close: {
        en: "Close",
        es: "Cerrar",
        it: "Chiudere",
        pt: "Fechar",
        de: "Schließen",
        nl: "Sluiten",
        zh: "关闭",
        ar: "إغلاق"
    },
    suplements: {
        en: "Supplements",
        es: "Suplementos",
        it: "Supplementi",
        pt: "Suplementos",
        de: "Ergänzungen",
        nl: "Supplementen",
        zh: "补助金",
        ar: "المكملات الغذائية",
        df: "Suppléments"
    },
    options: {
        en: "Options",
        es: "Opciones",
        it: "Opzioni",
        pt: "Opções",
        de: "Optionen",
        nl: "Opties",
        zh: "选项",
        ar: "الخيارات",
        df: "Options"
    },
    free: {
        en: "Free",
        es: "Gratis",
        it: "Gratuito",
        pt: "Grátis",
        de: "Kostenlos",
        nl: "Gratis",
        zh: "免费",
        ar: "مجاناً",
        df: "Gratuit"
    },
    add_to_cart: {
        df: "Ajouter au panier",
        en: "Add to cart",
        es: "Añadir al carrito",
        it: "Aggiungi al carrello",
        pt: "Adicionar ao carrinho",
        de: "In den Warenkorb",
        nl: "Toevoegen aan winkelwagen",
        zh: "加入购物车",
        ar: "أضف إلى السلة"
      },
      quantity: {
        df: "Quantité",
        en: "Quantity",
        es: "Cantidad",
        it: "Quantità",
        pt: "Quantidade",
        de: "Menge",
        nl: "Hoeveelheid",
        zh: "数量",
        ar: "الكمية"
      },
      view_order: {
        df: "Voir ma commande",
        en: "View my order",
        es: "Ver mi pedido",
        it: "Visualizza il mio ordine",
        pt: "Ver meu pedido",
        de: "Meine Bestellung ansehen",
        nl: "Mijn bestelling bekijken",
        zh: "查看我的订单",
        ar: "عرض طلبي"
      },
      your_order: {
        df: "Commande",
        en: "Your order",
        es: "Tu pedido",
        it: "Il tuo ordine",
        pt: "Seu pedido",
        de: "Ihre Bestellung",
        nl: "Uw bestelling",
        zh: "您的订单",
        ar: "طلبك"
      },
      
      validate_cart: {
        df: "Valider le panier",
        en: "Checkout",
        es: "Validar carrito",
        it: "Conferma il carrello",
        pt: "Validar carrinho",
        de: "Warenkorb bestätigen",
        nl: "Winkelwagen bevestigen",
        zh: "确认购物车",
        ar: "تأكيد السلة"
      },

      phone_login_title: {
        df: "Connectez-vous avec votre numéro de téléphone portable",
        en: "Sign in with your mobile phone number",
        es: "Inicia sesión con tu número de teléfono móvil",
        it: "Accedi con il tuo numero di telefono",
        pt: "Entre com seu número de telefone celular",
        de: "Melden Sie sich mit Ihrer Handynummer an",
        nl: "Log in met je mobiele nummer",
        zh: "使用您的手机号码登录",
        ar: "سجّل الدخول باستخدام رقم هاتفك المحمول"
      },
      
      phone_login_subtitle: {
        df: "Nous vous enverrons un code de vérification par SMS et n'utiliserons votre numéro que pour les mises à jour importantes de vos commandes",
        en: "We will send you a verification code by SMS and only use your number for important updates about your order",
        es: "Le enviaremos un código de verificación por SMS y solo utilizaremos su número para actualizaciones importantes de su pedido",
        it: "Ti invieremo un codice di verifica via SMS e useremo il tuo numero solo per aggiornamenti importanti sul tuo ordine",
        pt: "Enviaremos um código de verificação por SMS e usaremos seu número apenas para atualizações importantes do seu pedido",
        de: "Wir senden Ihnen einen Bestätigungscode per SMS und verwenden Ihre Nummer nur für wichtige Updates zu Ihrer Bestellung",
        nl: "We sturen je een verificatiecode per sms en gebruiken je nummer alleen voor belangrijke updates over je bestelling",
        zh: "我们将通过短信向您发送验证码，并仅在订单的重要更新中使用您的号码",
        ar: "سنرسل لك رمز تحقق عبر الرسائل القصيرة ولن نستخدم رقمك إلا للتحديثات المهمة حول طلبك"
      },
      
      continue: {
        df: "Continuer",
        en: "Continue",
        es: "Continuar",
        it: "Continua",
        pt: "Continuar",
        de: "Weiter",
        nl: "Doorgaan",
        zh: "继续",
        ar: "متابعة"
      },
      enter_code: {
        df: "Saisissez le code à 4 chiffres",
        en: "Enter the 4-digit code",
        es: "Introduce el código de 4 dígitos",
        it: "Inserisci il codice a 4 cifre",
        pt: "Digite o código de 4 dígitos",
        de: "Geben Sie den 4-stelligen Code ein",
        nl: "Voer de 4-cijferige code in",
        zh: "输入4位验证码",
        ar: "أدخل الرمز المكوّن من 4 أرقام"
      },
      
      code_sent_to: {
        df: "Votre code a été envoyé à",
        en: "Your code has been sent to",
        es: "Tu código ha sido enviado a",
        it: "Il tuo codice è stato inviato a",
        pt: "Seu código foi enviado para",
        de: "Ihr Code wurde an gesendet",
        nl: "Je code is verzonden naar",
        zh: "验证码已发送至",
        ar: "تم إرسال الرمز إلى "
      },
      
      code_placeholder: {
        df: "Code",
        en: "Code",
        es: "Código",
        it: "Codice",
        pt: "Código",
        de: "Code",
        nl: "Code",
        zh: "验证码",
        ar: "الرمز"
      },
      
      last_step: {
        df: "Dernière étape",
        en: "Final step",
        es: "Último paso",
        it: "Ultimo passaggio",
        pt: "Última etapa",
        de: "Letzter Schritt",
        nl: "Laatste stap",
        zh: "最后一步",
        ar: "الخطوة الأخيرة"
      },
      
      profile_subtitle: {
        df: "Ajoutez votre prénom et votre email afin de recevoir votre reçu et des promotions",
        en: "Add your first name and email to receive your receipt and promotions",
        es: "Añade tu nombre y tu correo electrónico para recibir tu recibo y promociones",
        it: "Aggiungi il tuo nome e la tua email per ricevere la ricevuta e le promozioni",
        pt: "Adicione seu nome e e-mail para receber seu recibo e promoções",
        de: "Fügen Sie Ihren Vornamen und Ihre E-Mail hinzu, um Ihre Quittung und Angebote zu erhalten",
        nl: "Voeg je voornaam en e-mail toe om je ontvangstbewijs en promoties te ontvangen",
        zh: "添加您的姓名和电子邮件以接收收据和促销信息",
        ar: "أضف اسمك وبريدك الإلكتروني لتلقي إيصالك والعروض"
      },
      
      first_name: {
        df: "Prénom",
        en: "First name",
        es: "Nombre",
        it: "Nome",
        pt: "Nome",
        de: "Vorname",
        nl: "Voornaam",
        zh: "名字",
        ar: "الاسم الأول"
      },
      
      email: {
        df: "Email",
        en: "Email",
        es: "Correo electrónico",
        it: "Email",
        pt: "Email",
        de: "E-Mail",
        nl: "E-mail",
        zh: "电子邮件",
        ar: "البريد الإلكتروني"
      },
      
      no_promotions: {
        df: "Je ne veux pas recevoir de promotions",
        en: "I do not want to receive promotions",
        es: "No quiero recibir promociones",
        it: "Non desidero ricevere promozioni",
        pt: "Não quero receber promoções",
        de: "Ich möchte keine Werbeaktionen erhalten",
        nl: "Ik wil geen promoties ontvangen",
        zh: "我不想接收促销信息",
        ar: "لا أرغب في تلقي العروض الترويجية"
      },
      first_name_required: {
        df: "Prénom requis",
        en: "First name is required",
        es: "Nombre obligatorio",
        it: "Nome obbligatorio",
        pt: "Nome obrigatório",
        de: "Vorname erforderlich",
        nl: "Voornaam verplicht",
        zh: "名字为必填项",
        ar: "الاسم الأول مطلوب"
      },
      
      email_required: {
        df: "Email requis",
        en: "Email is required",
        es: "Correo electrónico obligatorio",
        it: "Email obbligatoria",
        pt: "Email obrigatório",
        de: "E-Mail erforderlich",
        nl: "E-mail verplicht",
        zh: "电子邮件为必填项",
        ar: "البريد الإلكتروني مطلوب"
      },
      
      email_invalid: {
        df: "Email invalide",
        en: "Invalid email address",
        es: "Correo electrónico inválido",
        it: "Email non valida",
        pt: "Email inválido",
        de: "Ungültige E-Mail-Adresse",
        nl: "Ongeldig e-mailadres",
        zh: "无效的电子邮件地址",
        ar: "عنوان بريد إلكتروني غير صالح"
      },
      invalid_phone_number: {
        df: "Numéro de téléphone invalide",
        en: "Invalid phone number",
        es: "Número de teléfono inválido",
        it: "Numero di telefono non valido",
        pt: "Número de telefone inválido",
        de: "Ungültige Telefonnummer",
        nl: "Ongeldig telefoonnummer",
        zh: "无效的电话号码",
        ar: "رقم هاتف غير صالح"
      },

      phone_invalid: {
        df: "Numéro de téléphone invalide",
        en: "Invalid phone number",
        es: "Número de teléfono inválido",
        it: "Numero di telefono non valido",
        pt: "Número de telefone inválido",
        de: "Ungültige Telefonnummer",
        nl: "Ongeldig telefoonnummer",
        zh: "无效的电话号码",
        ar: "رقم هاتف غير صالح"
      },
      
      sms_send_failed: {
        df: "Impossible d'envoyer le SMS. (DEV: vérifiez les numéros de test Firebase)",
        en: "Unable to send SMS. (DEV: check Firebase test numbers)",
        es: "No se pudo enviar el SMS. (DEV: verifica los números de prueba en Firebase)",
        it: "Impossibile inviare l'SMS. (DEV: verifica i numeri di test Firebase)",
        pt: "Não foi possível enviar o SMS. (DEV: verifique os números de teste no Firebase)",
        de: "SMS konnte nicht gesendet werden. (DEV: Firebase-Testnummern prüfen)",
        nl: "SMS kon niet worden verzonden. (DEV: controleer Firebase-testnummers)",
        zh: "无法发送短信。（开发环境：请检查 Firebase 测试号码）",
        ar: "تعذر إرسال الرسالة النصية. (بيئة التطوير: تحقق من أرقام اختبار Firebase)"
      },
      
      sms_not_sent: {
        df: "Erreur : SMS non envoyé.",
        en: "Error: SMS not sent.",
        es: "Error: SMS no enviado.",
        it: "Errore: SMS non inviato.",
        pt: "Erro: SMS não enviado.",
        de: "Fehler: SMS nicht gesendet.",
        nl: "Fout: SMS niet verzonden.",
        zh: "错误：短信未发送。",
        ar: "خطأ: لم يتم إرسال الرسالة."
      },
      
      code_invalid: {
        df: "Code invalide.",
        en: "Invalid code.",
        es: "Código inválido.",
        it: "Codice non valido.",
        pt: "Código inválido.",
        de: "Ungültiger Code.",
        nl: "Ongeldige code.",
        zh: "验证码无效。",
        ar: "رمز غير صالح."
      },
      
      code_incorrect: {
        df: "Code incorrect. Réessayez.",
        en: "Incorrect code. Please try again.",
        es: "Código incorrecto. Inténtalo de nuevo.",
        it: "Codice errato. Riprova.",
        pt: "Código incorreto. Tente novamente.",
        de: "Falscher Code. Bitte erneut versuchen.",
        nl: "Onjuiste code. Probeer opnieuw.",
        zh: "验证码错误。请重试。",
        ar: "رمز غير صحيح. حاول مرة أخرى."
      },

        phone_invalid_fr: {
          fr: "Numéro de téléphone invalide (France uniquement)",
          en: "Invalid phone number (France only)",
          es: "Número de teléfono no válido (solo Francia)",
          it: "Numero di telefono non valido (solo Francia)",
          de: "Ungültige Telefonnummer (nur Frankreich)",
          pt: "Número de telefone inválido (apenas França)",
          nl: "Ongeldig telefoonnummer (alleen Frankrijk)",
          ar: "رقم هاتف غير صالح (فرنسا فقط)",
          zh: "电话号码无效（仅限法国）"
        },
finalize_order: {
  en: "Finalize order",
  es: "Finalizar pedido",
  it: "Finalizza l'ordine",
  pt: "Finalizar pedido",
  de: "Bestellung abschließen",
  nl: "Bestelling afronden",
  zh: "完成订单",
  ar: "إتمام الطلب",
  df: "Finaliser"
},

service_type: {
  en: "Service type",
  es: "Tipo de servicio",
  it: "Tipo di servizio",
  pt: "Tipo de serviço",
  de: "Servicetyp",
  nl: "Type service",
  zh: "服务类型",
  ar: "نوع الخدمة",
  df: "Type de service"
},

at_table: {
  en: "At table",
  es: "En mesa",
  it: "Al tavolo",
  pt: "À mesa",
  de: "Am Tisch",
  nl: "Aan tafel",
  zh: "堂食",
  ar: "على الطاولة",
  df: "À table"
},

take_away: {
  en: "Take away",
  es: "Para llevar",
  it: "Da asporto",
  pt: "Para levar",
  de: "Zum Mitnehmen",
  nl: "Afhalen",
  zh: "外带",
  ar: "سفري",
  df: "À emporter"
},

table_number: {
  en: "Table number",
  es: "Número de mesa",
  it: "Numero del tavolo",
  pt: "Número da mesa",
  de: "Tischnummer",
  nl: "Tafelnummer",
  zh: "桌号",
  ar: "رقم الطاولة",
  df: "Numéro de table"
},

table: {
  en: "Table",
  es: "Mesa",
  it: "Tavolo",
  pt: "Mesa",
  de: "Tisch",
  nl: "Tafel",
  zh: "桌",
  ar: "طاولة",
  df: "Table"
},

tip: {
  en: "Tip",
  es: "Propina",
  it: "Mancia",
  pt: "Gorjeta",
  de: "Trinkgeld",
  nl: "Fooi",
  zh: "小费",
  ar: "إكرامية",
  df: "Pourboire"
},

kitchen_comment: {
  en: "Add a comment for the kitchen",
  es: "Añadir un comentario para la cocina",
  it: "Aggiungi un commento per la cucina",
  pt: "Adicionar um comentário para a cozinha",
  de: "Kommentar für die Küche hinzufügen",
  nl: "Voeg een opmerking toe voor de keuken",
  zh: "给厨房添加备注",
  ar: "أضف تعليقًا للمطبخ",
  df: "Ajouter un commentaire"
},

payment_method: {
  en: "Payment method",
  es: "Método de pago",
  it: "Metodo di pagamento",
  pt: "Método de pagamento",
  de: "Zahlungsmethode",
  nl: "Betaalmethode",
  zh: "支付方式",
  ar: "طريقة الدفع",
  df: "Mode de paiement"
},

card: {
  en: "Card",
  es: "Tarjeta",
  it: "Carta",
  pt: "Cartão",
  de: "Karte",
  nl: "Kaart",
  zh: "银行卡",
  ar: "بطاقة",
  df: "Carte"
},

order: {
  en: "Order",
  es: "Pedido",
  it: "Ordine",
  pt: "Pedido",
  de: "Bestellung",
  nl: "Bestelling",
  zh: "订单",
  ar: "الطلب",
  df: "Commande"
},

total_amount: {
  en: "Total amount",
  es: "Importe total",
  it: "Importo totale",
  pt: "Total",
  de: "Gesamtbetrag",
  nl: "Totaalbedrag",
  zh: "总金额",
  ar: "المبلغ الإجمالي",
  df: "Montant total"
},

pay_with: {
  en: "Pay with",
  es: "Pagar con",
  it: "Paga con",
  pt: "Pagar com",
  de: "Bezahlen mit",
  nl: "Betalen met",
  zh: "使用以下方式支付",
  ar: "ادفع باستخدام",
  df: "Payer par"
},


      

};

export default translations;